import { Cascader, Tabs } from 'antd'
import { CascaderOptionType } from 'antd/lib/cascader'
import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import shallow from 'zustand/shallow'
import { PerTabBarContent } from '../../../components/custom_components/TabBarContent'
import { filterCountriesByReportType, insertElementAtPositionIntoArray } from '../../../shared/downloadsUtil'
import { CountryAndReportGenerationFlags } from '../../../types'
import { allCountriesOption, noFilterOption, useReportStore } from '../ReportStore'
import { ReportTab } from '../types'

const { TabPane } = Tabs

interface ReportsHeaderProps {
  reportGenerationData: CountryAndReportGenerationFlags[]
}

export const ReportsHeader: FC<ReportsHeaderProps> = ({ reportGenerationData }) => {
  const [t] = useTranslation()

  const [storeInitialized, activeTab, setActiveTab, countries, mappedCountries, setMappedCountries, selectedCountry, setSelectedCountry] =
    useReportStore(
      (state) => [
        state.storeInitialized,
        state.activeTab,
        state.setActiveTab,
        state.countries,
        state.mappedCountries,
        state.setMappedCountries,
        state.selectedCountry,
        state.setSelectedCountry,
      ],
      shallow,
    )

  const onDropDownChanged = (value: string) => {
    if (!!value) {
      setSelectedCountry(value)
    } else {
      setSelectedCountry(noFilterOption.value)
    }
  }

  useEffect(() => {
    if (storeInitialized) {
      const data = filterCountriesByReportType(activeTab!, reportGenerationData)
      // Remove country ALL from options if not all countries are available for the report type, otherwise add it if not already there
      if (data.some((el) => countries.indexOf(el.country) === -1) || activeTab === ReportTab.RankingReport) {
        if (mappedCountries.some((el) => el.label === allCountriesOption.label)) {
          if (selectedCountry.label === allCountriesOption.label) {
            setSelectedCountry(noFilterOption.value)
          }
          setMappedCountries(mappedCountries.filter((el) => el.label !== allCountriesOption.label))
        }
      } else {
        if (!mappedCountries.some((el) => el.label === allCountriesOption.label)) {
          const newMappedCountries = insertElementAtPositionIntoArray(mappedCountries, allCountriesOption, 1)
          setMappedCountries(newMappedCountries as CascaderOptionType[])
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab])

  return (
    <PerTabBarContent
      tabs={
        <>
          <Tabs activeKey={activeTab} onChange={(key) => setActiveTab(key as ReportTab)}>
            <TabPane tab={t('reports.header.meetingReports')} key={ReportTab.MeetingReport} />
            <TabPane tab={t('reports.header.bigReports')} key={ReportTab.BigReport} />
            <TabPane tab={t('reports.header.rankingReports')} key={ReportTab.RankingReport} />
            <TabPane tab={t('reports.header.pyramidsReports')} key={ReportTab.PyramidReport} />
          </Tabs>
        </>
      }
      actions={
        activeTab &&
        [ReportTab.MeetingReport, ReportTab.BigReport, ReportTab.RankingReport, ReportTab.PyramidReport].includes(activeTab) && (
          <Cascader
            options={mappedCountries}
            onChange={(newVal) => {
              onDropDownChanged(newVal[0])
            }}
            style={{ marginLeft: '3.5px' }}
            allowClear={false}
            defaultValue={[noFilterOption.value]}
            value={
              !!selectedCountry
                ? [selectedCountry.label, selectedCountry.value, selectedCountry.key]
                : [noFilterOption.label, noFilterOption.value, noFilterOption.key]
            }
          />
        )
      }
    />
  )
}
